import React from 'react';
import { Form, Button, Col } from 'react-bootstrap';
import Select from 'react-select';
import { Link } from "react-router-dom";


const SalesAnalysisCustomerReport = () => {
  const accountOptions = [
    { value: '', label: 'All' },
    { value: '144545', label: '2ingis s.a.' },
    { value: '71159', label: 'ALL SAINTS DENTAL' },
    { value: '137334', label: 'Andrew Lee (Diu Resh)' },
    { value: '109766', label: 'Andrew Lee Dental (Roebuck Louise)' },
    { value: '109767', label: 'Andrew Lee Dental (T Hyare)' },
    { value: '75777', label: 'Holloway House Dental (Ajith George)' }
  ];

  const tagOptions = [
    { value: '', label: 'No filter' },
    { value: 'a-practices', label: 'a-practices' },
    { value: 'bhandal', label: 'bhandal' },
    { value: 'coventry-dental', label: 'coventry-dental' },
    { value: 'dental-beauty', label: 'dental-beauty' },
    { value: 'murray-dental-', label: 'murray-dental-' },
    { value: 'swissmeda', label: 'swissmeda' }
  ];

  // Inline styling
  const containerStyle = {
    maxWidth: '600px',
 
    padding: '20px',
    border: '1px solid #ced4da',
    borderRadius: '0.25rem',
    boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)',
    backgroundColor: '#f8f9fa',
  };

  const selectStyle = {
    marginBottom: '15px',
    borderColor: '#ced4da',
    borderRadius: '0.25rem',
  };
  const legendStyle = {
    fontSize: '1.5rem',
    marginBottom: '20px',
    color: '#343a40',
  };

  return (
  <>

 <h2 className="text-left mb-4" style={{ color: 'black' }}>Parameters</h2>
    <Form
      action="/lab/reports/view/report/sales-analysis-customer"
      method="get"
      style={containerStyle}
      id="report_sales_analysis_customer"
      acceptCharset="utf-8"
    >
      <fieldset>
        <legend style={legendStyle}>Parameters</legend>

        <Form.Group as={Col}>
          <Form.Label htmlFor="sales_analysis_customer_practice">
            Accounts
          </Form.Label>
          <Select
            id="sales_analysis_customer_practice"
            options={accountOptions}
            isMulti
            placeholder="Select accounts"
            className="react-select-container"
            classNamePrefix="react-select"
            styles={{
              control: (provided) => ({
                ...provided,
                ...selectStyle,
                boxShadow: 'none',
                '&:hover': {
                  borderColor: '#007bff',
                },
              }),
            }}
          />
          <Form.Check
            type="checkbox"
            id="include_closed"
            name="include_closed"
            value="1"
            label="Include Closed"
            style={{ marginLeft: '5px' }}
          />
        </Form.Group>

        <Form.Group as={Col}>
          <Form.Label htmlFor="report_sales_analysis_customer_account_tags">
            Account Tags
          </Form.Label>
          <Select
            id="report_sales_analysis_customer_account_tags"
            options={tagOptions}
            isMulti
            placeholder="Select tags to filter report"
            className="react-select-container"
            classNamePrefix="react-select"
            styles={{
              control: (provided) => ({
                ...provided,
                ...selectStyle,
                boxShadow: 'none',
                '&:hover': {
                  borderColor: '#007bff',
                },
              }),
            }}
          />
        </Form.Group>

        <Form.Group as={Col}>
          <Form.Label htmlFor="report_sales_analysis_customer_format">
            Format <span className="form_required">*</span>
          </Form.Label>
          <Form.Control
            as="select"
            id="report_sales_analysis_customer_format"
            name="format"
            required
            style={selectStyle}
          >
            <option value="">On Screen</option>
            <option value="csv">CSV (Excel)</option>
          </Form.Control>
        </Form.Group>
        <Form.Group >
         <Col sm={{ span: 8, offset: 4 }}>
           <Link to="/Addunitsale">
             <Button
               id="pay-per-task-submit"
               type="button"
               variant="primary"
               className="w-100 mt-2"
               style={{
                 backgroundColor: '#004aad',
                 borderColor: '#004aad',
                 marginTop: '10px',
               }}
             >
               Run
             </Button>
           </Link>
         </Col>
        </Form.Group>
      </fieldset>
    </Form>
    </>
  );
};

export default SalesAnalysisCustomerReport;
